import $ from 'jquery';

// Initializes Bootstrap DateTime Pickers for pages with #start-date and #end-date fields.
// Use data-set-end-date on the #start-date input to pass a server-formatted end date constraint,
// otherwise the current value of #end-date is used.
$(document).ready(function() {
  if (!$('#start-date').length) return;

  // Prefer an explicit data-set-end-date attribute; fall back to the field's current value
  var endDateValue = $('#start-date').data('set-end-date') || $('#end-date').val();

  $("#start-date").datetimepicker({
    format: 'yyyy-mm-dd',
    startView: 2,
    minView: 2,
    setEndDate: endDateValue,
    maxView: 3,
    bootcssVer: 3,
    autoclose: true,
  });

  $("#end-date").datetimepicker({
    format: 'yyyy-mm-dd',
    startView: 2,
    minView: 2,
    maxView: 3,
    bootcssVer: 3,
    autoclose: true,
  });
});
